'use strict';
const angular = require('angular');

/*@ngInject*/
export function VotingsService($resource) {
  return $resource('/api/votings/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
     method: 'PATCH',
     url: "/api/votings/:id"
    },
    castVote: {
      method: 'POST',
      url: "/api/votings/:id/voters/:voterId/:propertyId/cast"
    },
    getVotes: {
      method: 'GET',
      url: '/api/votings/:id/votes',
      isArray: true
    },
    getVotesByBallot: {
      method: 'GET',
      url: '/api/votings/:id/ballot/:ballotId/votes',
      isArray: true
    },
    getMyEvents: {
      method: 'GET',
      url: '/api/votings/me',
      isArray: true
    },
    updateProxy: {
      method: 'PUT',
      url: "/api/votings/:id/property/:propertyId/proxy"
    },
    updateAttendance: {
      method: 'PUT',
      url: "/api/votings/:id/property/:propertyId/attendance"
    },
    upsertNonSecretVote: {
      method: 'PUT',
      url: "/api/votings/:id/voters/:voterId/:propertyId/upsert-non-secret-vote"
    },
    removeNonSecretVote: {
      method: 'DELETE',
      url: "/api/votings/:id/ballot/:ballotId/property/:propertyId/vote/:voteId/:reason"
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/votings/:id/attachments"
    }
});
}


export default angular.module('conduu.VotingsService', [])
  .factory('VotingsService', VotingsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/votings/votings.service.js